import React, { useState, useEffect, useCallback } from "react";
import Logo from "../../images/Viridi.png";
import ic1 from "../../images/dbicn.png";
import ic2 from "../../images/congicon.png";
import ic3 from "../../images/invicn.png";
import ic4 from "../../images/ordicn.png";
import ic5 from "../../images/prdicn.png";
import ic6 from "../../images/supplyicn.png";
import ic7 from "../../images/reporticn.png";
import ic8 from "../../images/simicn.png";
import group from "../../images/Group.png";
import Business from "../../images/Business.png";
import Department from "../../images/Department.png";
import User from "../../images/User.png";
import Group from "../../images/Group.png";
import Faqicon from "../../images/faq.png";
import { useNavigate } from "react-router-dom";
import rarrow from "../../images/rightarrow.png";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TranslateComponent from "../../components/googleTranslate/TranslateComponent";

const Leftpanel = ({ breadcm }) => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // console.log(JSON.parse(localStorage.getItem("gs3_User")).AssignRoleModules.map(item=>item.modulename),"LLLLLLLL");
  }, []);

  const [show, setShow] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [sideMenu, setSideMenu] = useState([
    {
      label: "Configuration",
      value: false,
    },
    {
      label: "Order",
      value: false,
    },
    {
      label: "Invoice",
      value: false,
    },
    {
      label: "Product",
      value: false,
    },
    {
      label: "Vendor",
      value: false,
    },
    {
      label: "Other",
      value: false,
    },
    {
      label: "Report",
      value: false,
    },
  ]);

  const navigate = useNavigate();

  const _CHECK_PERMISION = (moduleType) => {
    return JSON.parse(
      localStorage.getItem("gs3_User")
    )?.UserJobRole?.AssignRoleModules.some(
      (item) => item?.modulename === moduleType
    );
  };
  useEffect(() => {
    setSideMenu(
      sideMenu.map((data) => ({
        ...data,
        value:
          data.label === breadcm ||
          (breadcm === "Other" && data.label === "Configuration"),
      }))
    );
  }, [breadcm]);

  const handleTab = (text) => {
    setSideMenu((prevSideMenu) => {
      if (text === "Other") {
        const isOtherCurrentlyTrue = prevSideMenu.find(
          (data) => data.label === "Other"
        ).value;

        return prevSideMenu.map((data) => {
          if (data.label === "Other") {
            return { ...data, value: !isOtherCurrentlyTrue };
          } else if (data.label === "Configuration") {
            return { ...data, value: !isOtherCurrentlyTrue || data.value };
          } else {
            return data;
          }
        });
      } else {
        return prevSideMenu.map((data) => ({
          ...data,
          value: data.label === text ? !data.value : false,
        }));
      }
    });
  };

  return (
    localStorage.getItem("gs3_AuthToken") && (
      <>
        <span
          className="barIcon"
          style={{
            position: "absolute",
            top: "16px",
            zIndex: "999",
          }}
          onClick={() => {
            setShow(!show);
          }}
        >
          {show ? (
            <i className="fa-solid fa-bars pointer"></i>
          ) : (
            <i className="fa-solid fa-xmark p-3 pointer"></i>
          )}
        </span>

        <div
          className={`border ${show ? "leftPanel" : "leftPanel showleftpanel"}`}
          style={{ width: isOpen ? "320px" : "120px", position: "relative" }}
        >
          <div className="lpLogo">
            <img src={Logo} alt="" style={{ width: !isOpen ? "65px" : "" }} />
          </div>
          <span onClick={() => setIsOpen(!isOpen)} className="openarrow">
            <img
              src={rarrow}
              alt=""
              style={{
                width: "20px",
                transform: isOpen ? "rotate(180deg)" : "",
                cursor: "pointer",
              }}
            />
          </span>
          <div
            className="accordion lpAccordion"
            id="accordionExample"
            style={{ position: "relative" }}
          >
            <div className="accordion-item">
              {
                // _CHECK_PERMISION('Dashboard') &&
                <Link to="/dashboard">
                  {" "}
                  <span className="dbIcn">
                    <img src={ic1} alt="" />
                  </span>
                  {isOpen && (
                    <span className="ms-1 d-none d-sm-inline">
                      {t("Dashboard")}
                    </span>
                  )}
                  {isOpen && (
                    <span className="arrwIcn">
                      <img src={rarrow} alt="" />
                    </span>
                  )}
                </Link>
              }

              {/* {(_CHECK_PERMISION('Configuration') || 
                   _CHECK_PERMISION('Business Unit') || 
                   _CHECK_PERMISION('Department') || 
                   _CHECK_PERMISION('Users')
                   ) 
                   && */}
              <div
                className="submenu1"
                onClick={() => handleTab("Configuration")}
              >
                <Link
                  to=""
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  <span className="dbIcn">
                    <img src={ic2} alt="" />
                  </span>
                  {isOpen && <span>{t("Configurations")}</span>}
                  {isOpen && (
                    <span className="arrwIcn">
                      <img src={rarrow} alt="" />
                    </span>
                  )}
                </Link>
              </div>
              {/* } */}
              <div
                id=""
                className={`accordion-collapse collapse ${
                  sideMenu[0].value ? "show" : ""
                }`}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {/* {_CHECK_PERMISION('Configuration') && */}
                  <Link to="/myprofile" className="actmyprof">
                    {" "}
                    <span className="dbIcn">
                      <img src={group} alt="" />
                    </span>
                    {isOpen && <span>&nbsp;{t("My Profile")}</span>}
                  </Link>
                  {["Configuration"].some((item) =>
                    JSON.parse(
                      localStorage.getItem("AssignRoleModules")
                    )?.includes(item)
                  ) && (
                    <Link to="/access-token" className="actToken">
                      {" "}
                      <span className="dbIcn">
                        <img src={group} alt="" />
                      </span>
                      {isOpen && <span>&nbsp;{t("access_tokens")}</span>}
                    </Link>
                  )}
                  {
                    // _CHECK_PERMISION('Configuration') &&
                    // (_CHECK_PERMISION('Business Unit')) &&
                    ["Configuration"].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) &&
                      ["Business Unit"].some((item) =>
                        JSON.parse(
                          localStorage.getItem("AssignRoleModules")
                        ).includes(item)
                      ) && (
                        <Link to="/businessunit" className="actbusinss">
                          {" "}
                          <span className="dbIcn">
                            <img src={Business} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{t("business_units")}</span>}
                        </Link>
                      )
                  }
                  {
                    // (
                    // _CHECK_PERMISION('Configuration')) &&
                    // (_CHECK_PERMISION('Department'))
                    // &&
                    ["Configuration"].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) &&
                      ["Department"].some((item) =>
                        JSON.parse(
                          localStorage.getItem("AssignRoleModules")
                        ).includes(item)
                      ) && (
                        <Link to="/department" className="actdepart">
                          {" "}
                          <span className="dbIcn">
                            <img src={Department} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{t("departments")}</span>}
                        </Link>
                      )
                  }
                  {
                    // (_CHECK_PERMISION('Configuration')) &&
                    //     (_CHECK_PERMISION('Users')) &&
                    // ['Configuration'].some(item => JSON.parse(localStorage.getItem("gs3_User")).AssignRoleModules.map(item=>item.modulename).includes(item)) && ['Users'].some(item => JSON.parse(localStorage.getItem("gs3_User")).AssignRoleModules.map(item=>item.modulename).includes(item))

                    (["Configuration"].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) ||
                      ["Users"].some((item) =>
                        JSON.parse(
                          localStorage.getItem("AssignRoleModules")
                        ).includes(item)
                      )) && (
                      <Link to="/user" className="actusers">
                        {" "}
                        <span className="dbIcn">
                          <img src={User} alt="" />
                        </span>
                        {isOpen && <span>&nbsp;{t("Users")}</span>}
                      </Link>
                    )
                  }

                  {
                    // (_CHECK_PERMISION('Configuration') && (
                    //     _CHECK_PERMISION('Business Unit') ||
                    //     _CHECK_PERMISION('Department') ||
                    //     _CHECK_PERMISION('Users')
                    // ) && (_CHECK_PERMISION('Business Unit') && _CHECK_PERMISION('Department'))) &&
                    ["Configuration"].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) && (
                      <>
                        <div className="accordion" id="sub-accordionExample">
                          <div className="accordion-item">
                            <Link
                              to=""
                              className="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#sub-collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                              onClick={() => handleTab("Other")}
                            >
                              <span className="ms-1 d-none d-sm-inline">
                                <span className="dbIcn">
                                  <img src={Group} alt="" />
                                </span>
                                {isOpen && <span>&nbsp;{t("other")} </span>}
                              </span>
                              {isOpen && (
                                <span className="arrwIcn">
                                  <img src={rarrow} alt="" />
                                </span>
                              )}
                            </Link>

                            <div
                              id=""
                              className={`accordion-collapse collapse ${
                                sideMenu[5].value ? "show" : ""
                              }`}
                              aria-labelledby="sub-headingOne"
                              data-bs-parent="#sub-accordionExample"
                            >
                              <div className="accordion-body">
                                <Link to="/vat" className="nav-link px-0 vat">
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("VAT")}
                                    </span>
                                  )}
                                </Link>

                                <Link
                                  to="/esprovider"
                                  className="nav-link px-0 esprov"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("eis_company")}
                                    </span>
                                  )}
                                </Link>

                                {/* <Link to="/unspsc" className="nav-link px-0 unsps"> <span className="d-none d-sm-inline">UNSPSC</span></Link> */}

                                <Link to="/co2" className="nav-link px-0 cot">
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("co2e_emission")}
                                    </span>
                                  )}
                                </Link>

                                {/* <Link to="/glkey" className="nav-link px-0"> <span className="d-none d-sm-inline">GL Key</span></Link> */}

                                <Link
                                  to="/currency"
                                  className="nav-link px-0 curr"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("currencies")}
                                    </span>
                                  )}
                                </Link>

                                <Link
                                  to="/industry"
                                  className="nav-link px-0 indust"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("industries")}
                                    </span>
                                  )}
                                </Link>

                                <Link
                                  to="/segment"
                                  className="nav-link px-0 segm"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      UNSPSC
                                    </span>
                                  )}
                                </Link>
                                <Link
                                  to="/unitsofmeasure"
                                  className="nav-link px-0 segm"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("units_of_measures")}
                                    </span>
                                  )}
                                </Link>

                                <Link
                                  to="/qualitycontrol"
                                  className="nav-link px-0 qlty"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("quality_questions")}
                                    </span>
                                  )}
                                </Link>

                                <Link to="/ghg" className="nav-link px-0 ghg">
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("ghg_emissions_keys")}
                                    </span>
                                  )}
                                </Link>

                                <Link to="/gl" className="nav-link px-0 gl">
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("accounting_keys")}
                                    </span>
                                  )}
                                </Link>

                                <Link
                                  to="/edit-accounting-dimensions"
                                  className="nav-link px-0 ad"
                                >
                                  {" "}
                                  {isOpen && (
                                    <span className="d-none d-sm-inline">
                                      {t("Accounting dimensions")}
                                    </span>
                                  )}
                                </Link>
                              </div>
                            </div>
                          </div>
                          {/* <div className="accordion-item">
                                    <h2 className="accordion-header" id="sub-headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sub-collapseTwo" aria-expanded="false" aria-controls="sub-collapseTwo">
                                            Accordion Item #2
                                        </button>
                                    </h2>
                                    <div id="sub-collapseTwo" className="accordion-collapse collapse" aria-labelledby="sub-headingTwo" data-bs-parent="#sub-accordionExample">
                                        <div className="accordion-body">
                                            acc
                                        </div>
                                    </div>
                                </div> */}
                        </div>
                      </>
                    )
                  }
                  <Link to="/configuration-Faq" className="confaq">
                    {" "}
                    <span className="dbIcn">
                      <img src={Faqicon} alt="" />
                    </span>
                    {isOpen && <span>&nbsp;{t("Faq")}</span>}
                  </Link>
                </div>
              </div>
              {
                // _CHECK_PERMISION('Invoices') &&
                ["Invoices"].some((item) =>
                  JSON.parse(
                    localStorage.getItem("AssignRoleModules")
                  ).includes(item)
                ) && (
                  <>
                    <div className="submenu3">
                      <Link
                        to="/invoice"
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseInvoice"
                        aria-expanded="false"
                        aria-controls="collapseInvoice"
                        onClick={() => (
                          handleTab("Invoice"), navigate("/invoice")
                        )}
                      >
                        <span className="dbIcn">
                          <img src={ic3} alt="" />
                        </span>{" "}
                        {isOpen && <span>{t("Invoices")}</span>}
                        {isOpen && (
                          <span className="arrwIcn">
                            <img src={rarrow} alt="" />
                          </span>
                        )}
                      </Link>
                    </div>

                    <div
                      id=""
                      className={`accordion-collapse collapse ${
                        sideMenu[2].value ? "show" : ""
                      }`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Link to="/invoice" className="inv">
                          <span className="dbIcn">
                            <img src={ic3} alt="" />
                          </span>
                          {isOpen && <span>{t("Invoices")}</span>}
                        </Link>
                        <Link to="/invoicefaq" className="invfaq">
                          {" "}
                          <span className="dbIcn">
                            <img src={Faqicon} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{t("Faq")}</span>}
                        </Link>
                      </div>
                    </div>
                  </>
                )
              }

              {/* <Link to="" className="nav-link px-0 align-middle">
                        <span className='dbIcn'><img src={ic4} alt='' /></span>
                        <span>Orders</span> <span className='arrwIcn'><img src={rarrow} alt='' /></span></Link> */}
              {[
                "Orders",
                "PastOrder Approved",
                "PastOrder Approved with Issues",
                "PastOrder Received",
                "PastOrder Received with Issues",
              ].some((item) =>
                JSON.parse(localStorage.getItem("AssignRoleModules")).includes(
                  item
                )
              ) && (
                <div className="submenu2">
                  <Link
                    to="/order"
                    className="collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOrder"
                    aria-expanded="false"
                    aria-controls="collapseOrder"
                    onClick={() => handleTab("Order")}
                  >
                    <span className="dbIcn">
                      <img src={ic4} alt="" />
                    </span>{" "}
                    {isOpen && <span>{t("Purchase")}</span>}
                    {isOpen && (
                      <span className="arrwIcn">
                        <img src={rarrow} alt="" />
                      </span>
                    )}
                  </Link>
                </div>
              )}
              <div
                id=""
                className={`accordion-collapse collapse ${
                  sideMenu[1]?.value ? "show" : ""
                } `}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <Link to="/pastorder" className="pordr">
                    {" "}
                    <span className="dbIcn">
                      <img src={ic1} alt="" />
                    </span>
                    {isOpen && <span>{t("orders")}</span>}
                  </Link>
                  {
                    // (_CHECK_PERMISION('Orders') &&
                    //     !(_CHECK_PERMISION('PastOrder Approved with Issues') || _CHECK_PERMISION('PastOrder Approved') ||
                    //         _CHECK_PERMISION('PastOrder Received with Issues') ||
                    //         _CHECK_PERMISION('PastOrder Received')
                    //     )) &&
                    [
                      "PastOrder Approved with Issues",
                      "PastOrder Approved",
                      "PastOrder Received",
                      "PastOrder Received with Issues",
                    ].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) && (
                      <Link to="/purchaseorder" className="purdr">
                        {" "}
                        <span className="dbIcn">
                          <img src={ic1} alt="" />
                        </span>
                        {isOpen && <span>{t("Purchase Orders")}</span>}
                      </Link>
                    )
                  }
                  {
                    // (_CHECK_PERMISION('Orders') &&
                    //     !(_CHECK_PERMISION('PastOrder Approved with Issues') || _CHECK_PERMISION('PastOrder Approved') ||
                    //         _CHECK_PERMISION('PastOrder Received with Issues') ||
                    //         _CHECK_PERMISION('PastOrder Received')
                    //     )) &&
                    ![
                      "PastOrder Approved with Issues",
                      "PastOrder Approved",
                      "PastOrder Received",
                      "PastOrder Received with Issues",
                    ].some((item) =>
                      JSON.parse(
                        localStorage.getItem("AssignRoleModules")
                      ).includes(item)
                    ) && (
                      <Link to="/" className="cordr">
                        {" "}
                        <span className="dbIcn">
                          <img src={ic1} alt="" />
                        </span>
                        {isOpen && <span>{t("Cost Registration")}</span>}
                      </Link>
                    )
                  }

                  <Link to="/orderfaq" className="ordfaq">
                    {" "}
                    <span className="dbIcn">
                      <img src={Faqicon} alt="" />
                    </span>
                    {isOpen && <span>&nbsp;{t("Faq")}</span>}
                  </Link>
                </div>
              </div>

              {/* <Link to="/invoice" className="nav-link px-0 align-middle invoiceLink">
                        <span className='dbIcn'><img src={ic3} alt='' /></span>
                        <span>Invoices</span> </Link> */}

              {/* <Link to="/products" className="nav-link px-0 align-middle productLink">
                        <span className='prdt'><img src={ic5} alt='' /></span> 
                        <span>Products</span> </Link> */}
              {
                // _CHECK_PERMISION('Products') &&
                ["Products"].some((item) =>
                  JSON.parse(
                    localStorage.getItem("AssignRoleModules")
                  ).includes(item)
                ) && (
                  <>
                    <div className="submenu4">
                      <Link
                        to="/products"
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseProduct"
                        aria-expanded="false"
                        aria-controls="collapseProduct"
                        onClick={() => (
                          handleTab("Product"), navigate("/products")
                        )}
                      >
                        <span className="dbIcn">
                          <img src={ic5} alt="" />
                        </span>{" "}
                        {isOpen && <span>{t("products")}</span>}
                        {isOpen && (
                          <span className="arrwIcn">
                            <img src={rarrow} alt="" />
                          </span>
                        )}
                      </Link>
                    </div>

                    <div
                      id=""
                      className={`accordion-collapse collapse ${
                        sideMenu[3].value ? "show" : ""
                      }`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Link to="/products" className="productLink">
                          <span className="prdt">
                            <img src={ic5} alt="" />
                          </span>
                          {isOpen && <span>{t("products")}</span>}
                        </Link>
                        <Link to="/productfaq" className="prdfaq">
                          {" "}
                          <span className="dbIcn">
                            <img src={Faqicon} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{t("Faq")}</span>}
                        </Link>
                      </div>
                    </div>
                  </>
                )
              }

              {/* <Link to="" className="collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span className='dbIcn'><img src={ic5} alt='' /></span> <span>Products</span> <span className='arrwIcn'><img src={rarrow} alt='' /></span> </Link>


                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <Link to=""> <span className='dbIcn'><img src={ic1} alt='' /></span><span>Product 1</span> </Link>
                            <Link to="/"> <span className='dbIcn'><img src={ic1} alt='' /></span><span>Product 2</span> </Link>
                        </div>
                    </div> */}

              {/* <Link to="/suppliers" className="nav-link px-0 align-middle supplierlink">
                        <span className='dbIcn'><img src={ic6} alt='' /></span> <span>Suppliers</span> </Link> */}
              {
                // _CHECK_PERMISION('Suppliers') &&
                ["Suppliers"].some((item) =>
                  JSON.parse(
                    localStorage.getItem("AssignRoleModules")
                  ).includes(item)
                ) && (
                  <>
                    <div className="submenu5">
                      <Link
                        to="/suppliers"
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSupplier"
                        aria-expanded="false"
                        aria-controls="collapseSupplier"
                        onClick={() => (
                          handleTab("Supplier"),
                          navigate("/suppliers"),
                          localStorage.setItem("tab", "Supplier")
                        )}
                      >
                        <span className="dbIcn">
                          <img src={ic6} alt="" />
                        </span>{" "}
                        {isOpen && <span>{t("suppliers")}</span>}
                        {isOpen && (
                          <span className="arrwIcn">
                            <img src={rarrow} alt="" />
                          </span>
                        )}
                      </Link>
                    </div>

                    <div
                      id=""
                      className={`accordion-collapse collapse ${
                        sideMenu[4].value ? "show" : ""
                      }`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Link to="/suppliers" className="supplierlink">
                          <span className="dbIcn">
                            <img src={ic6} alt="" />
                          </span>{" "}
                          {isOpen && <span>{t("suppliers")}</span>}
                        </Link>

                        <Link to="/supplierfaq" className="supfaq">
                          {" "}
                          <span className="dbIcn">
                            <img src={Faqicon} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{t("Faq")}</span>}
                        </Link>
                      </div>
                    </div>
                  </>
                )
              }

              {
                // _CHECK_PERMISION('Reports') &&
                ["Reports"].some((item) =>
                  JSON.parse(
                    localStorage.getItem("AssignRoleModules")
                  ).includes(item)
                ) && (
                  <>
                    <div className="submenu6">
                      <Link
                        to="/report"
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseReport"
                        aria-expanded="false"
                        aria-controls="collapseReport"
                        onClick={() => (
                          handleTab("Report"),
                          navigate("/report"),
                          localStorage.setItem("tab", "Report")
                        )}
                      >
                        <span className="dbIcn">
                          {/* <img src={ic6} alt="" /> */}
                          <i className="fa-solid fa-chart-column"></i>
                        </span>{" "}
                        {isOpen && <span>{"Report"}</span>}
                        {isOpen && (
                          <span className="arrwIcn">
                            <img src={rarrow} alt="" />
                          </span>
                        )}
                      </Link>
                    </div>

                    {/* <div
                      id=""
                      className={`accordion-collapse collapse ${
                        sideMenu[6].value ? "show" : ""
                      }`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Link to="/report" className="supplierlink">
                          <span className="dbIcn">
                            <img src={ic6} alt="" />
                          </span>{" "}
                          {isOpen && <span>{"UNSPSC"}</span>}
                        </Link>

                        <Link to="/report" className="supfaq">
                          {" "}
                          <span className="dbIcn">
                            <img src={Faqicon} alt="" />
                          </span>
                          {isOpen && <span>&nbsp;{"GHG"}</span>}
                        </Link>
                      </div>
                    </div> */}
                  </>
                )
              }

              {/* <div className='submenu6'>
                        <Link to="/suppliers" className="collapsed" data-bs-toggle="collapse" data-bs-target="#collapseReport" aria-expanded="false" aria-controls="collapseReport">
                        <span className='dbIcn'><img src={ic7} alt='' /></span> <span>Report List</span> <span className='arrwIcn'><img src={rarrow} alt='' /></span> </Link>
                        </div>

                        <div id="collapseReport" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                            <Link to=""><span className='dbIcn'><img src={ic7} alt='' /></span> <span>Reports</span> </Link>
                            </div>
                       </div> */}

              {/*<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Accordion Item #3
                    </button>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            accrd3
                        </div>
                    </div>*/}
            </div>
          </div>

          
          {/* <div className="">
              <TranslateComponent />
            </div> */}

        </div>
      </>
    )
  );
};

export default Leftpanel;
